import { Injectable } from '@angular/core';
import 'file-saver-es';

@Injectable({ providedIn: 'root' })
export class DownLoadFileService {
  blobToFile(data: Blob, type: string, filenameWithExt = 'export.txt') {
    const blob = new Blob([data], { type });
    window.saveAs(blob, filenameWithExt);
  }
}
